import { render, staticRenderFns } from "./evidencelist.vue?vue&type=template&id=576ca851&scoped=true"
import script from "./evidencelist.vue?vue&type=script&lang=js"
export * from "./evidencelist.vue?vue&type=script&lang=js"
import style0 from "./evidencelist.vue?vue&type=style&index=0&id=576ca851&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ca851",
  null
  
)

export default component.exports